/**
 * Where "Reprendre" leads: the movement last open in the session, not its
 * list. Leaving it mid-rest to glance at the journal, the way back is to the
 * bar, not to the choice of what to do next.
 */

type Store = Pick<Storage, "getItem" | "setItem">;

const key = (sessionId: number) => `resume:${sessionId}`;
const memory = new Map<string, string>();

function storage(): Store | null {
  try {
    return window.localStorage;
  } catch {
    return null;
  }
}

export function rememberExercise(sessionId: number, index: number, store: Store | null = storage()): void {
  memory.set(key(sessionId), String(index));
  try {
    store?.setItem(key(sessionId), String(index));
  } catch {
    /* the page's memory keeps it */
  }
}

/** The movement's screen when one was open, else the session's list. */
export function resumePath(sessionId: number, store: Store | null = storage()): string {
  let raw: string | null = null;
  try {
    raw = store?.getItem(key(sessionId)) ?? null;
  } catch {
    /* fall back on memory */
  }
  raw ??= memory.get(key(sessionId)) ?? null;
  const index = raw === null ? Number.NaN : Number(raw);
  return Number.isInteger(index) && index >= 0 ? `/seance/${sessionId}/exercice/${index}` : `/seance/${sessionId}`;
}
